import type { SorterResult } from 'antd/es/table/interface'

import { OrderType } from 'src/types'

import { useQueryUpdate } from './useQueryUpdate'

export const useTableSorter = () => {
  const { params, updateQuery } = useQueryUpdate()

  return <T>(sorter: SorterResult<T> | SorterResult<T>[]) => {
    const resolvedSorter = Array.isArray(sorter)
      ? sorter.find((item) => !!item?.order)
      : sorter
    const { order, column, columnKey, field } = (resolvedSorter ??
      {}) as SorterResult<T>
    const sortKey = column?.key ?? columnKey ?? field
    const ordering =
      order && sortKey
        ? `${order === OrderType.DESCEND ? '-' : ''}${String(sortKey)}`
        : null

    updateQuery({
      ...params,
      ordering
    })
  }
}
